import { render, staticRenderFns } from "./UnifiedActionDialog.vue?vue&type=template&id=61b28148&scoped=true"
import script from "./UnifiedActionDialog.vue?vue&type=script&lang=js"
export * from "./UnifiedActionDialog.vue?vue&type=script&lang=js"
import style0 from "./UnifiedActionDialog.vue?vue&type=style&index=0&id=61b28148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b28148",
  null
  
)

export default component.exports